import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { EmptyComponent, BaseComponent } from './home';
import { AuthGuard } from './core';
import { CatalogsComponent, CategoriesComponent, ProductsComponent, ProductLinkComponent } from './catalogs-formations';
import { StagesListComponent, StageDetailComponent } from './stages';
import { CyclefileComponent, CycleListComponent } from './cursus';
import { AdminCatalogsComponent, AdminCyclesComponent } from './admin';
//import { StagesListComponent2 } from './stages/stages-list/stages-list.component2';

const routes: Routes = [
  { path: '', redirectTo: 'home/empty', pathMatch: 'full' },
  { path: 'view/error', component: ErrorComponent },
  {
    path: 'home', children: [
      { path: 'empty', component: EmptyComponent, canActivate: [AuthGuard] },
      { path: 'base/:lang', component: BaseComponent, canActivate: [AuthGuard] },
      { path: 'base', component: BaseComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'catalogsFormations', children: [
      { path: 'catalogs', component: CatalogsComponent, canActivate: [AuthGuard] },
      { path: 'categories', component: CategoriesComponent, canActivate: [AuthGuard] },
      { path: 'products', component: ProductsComponent, canActivate: [AuthGuard] },
      { path: 'productlink', component: ProductLinkComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'stages', children: [
      //{ path: 'liststest', component: StagesListComponent, canActivate: [AuthGuard] },
      { path: 'lists', component: StagesListComponent, canActivate: [AuthGuard] },
      { path: 'details', component: StageDetailComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'cursus', children: [
      { path: 'cyclefile', component: CyclefileComponent, canActivate: [AuthGuard] },
      { path: 'cyclelist', component: CycleListComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'admin', children: [
      { path: 'catalogs', component: AdminCatalogsComponent, canActivate: [AuthGuard] },
      { path: 'cycles', component: AdminCyclesComponent, canActivate: [AuthGuard] },
      //{ path: 'config', component: ConfigComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
